import React, { useState } from 'react'
import CloseIcon from '../../../assets/icons/close.svg'
import { motion } from 'framer-motion'
import Animations from '../../../utils/animations'

const JOB_POSITION_ENABLED = false

import useStyles from '../AboutUs.styles'

export default function Team () {
  const classes = useStyles()

  const [legalExpanded, setLegalExpanded] = useState(false)

  const toggleLegalExpanded = () => {
    if (JOB_POSITION_ENABLED) {
      setLegalExpanded(!legalExpanded)
    }
  }

  return (
    <div className={classes.teamContainer}>
      <div className='px-5'>
        <h2 className={classes.teamTitle}>Our Team</h2>
        <p className={classes.teamSubtitle}>
          We are always improving our platform. If you’d like to join a multidisciplinary team
          dedicated to providing a seamless and extraordinary end-user experience, get in touch.{' '}
        </p>
      </div>
      <div className='d-flex row'>
        <div className='col-12 col-md-6 d-flex align-items-center justify-content-center p-5'>
          <div className='d-flex flex-column px-5'>
            <div className='web-subhead d-flex pb-4'>Join us</div>
            <div className='text-regular text-start pb-2'>
              We’re looking for people to join our team. Send us your resume.
            </div>
            <div className='d-table d-sm-flex justify-content-start pt-5 text-regular'>
              Send resume to:<b className='ps-3'> joinus@multikrd.com</b>
            </div>
          </div>
        </div>
        <div className='col-12 col-md-6 d-flex justify-content-center p-5'>
          <div className='d-flex flex-column w-100'>
            {roles.map(rol => {
              return (
                <div
                  key={rol}
                  className='about-links d-flex justify-content-between'
                  onClick={() => {
                    if (rol === 'Legal and Compliance') {
                      toggleLegalExpanded()
                    }
                  }}
                  style={{ cursor: JOB_POSITION_ENABLED ? 'pointer' : 'initial'}}
                >
                  <div className='about-links-text legal-link' style={{ color: '#0097EC' }}>
                    {rol}
                  </div>
                  <div />
                </div>
              )
            })}
            {JOB_POSITION_ENABLED && legalExpanded && (
              <motion.div
                className='text-regular text-start pt-2'
                style={{ marginTop: '10px' }}
                {...Animations.SLIDE_DOWN()}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <b>Position available: Senior Contract Analyst</b>
                  <img alt='close' src={CloseIcon} style={{ cursor: 'pointer' }} onClick={toggleLegalExpanded} />
                </div>
                Multikrd, LLC, Woodlands, Texas:
                <br />
                <br />
                <b>Duties:</b>
                <br />
                <br />
                <div style={{ marginLeft: '40px' }}>
                  • Review and analyze contracts in English and Spanish, including financing, sale,
                  distribution, licensing, and confidentiality agreements, collateralization agreements
                  and movable property liens under Mexican law, for the Company and its affiliates in
                  Mexico.
                  <br />
                  <br />
                  • Analyze contract clauses, stipulations, obligations, and liabilities and write
                  summaries of contract terms for use in management decision-making by the Company and
                  its affiliates in Mexico.
                  <br />
                  <br />
                  • Analyze the security interests of collateralized financing and loan agreements under
                  Mexican law, recommending improvements for execution in case of default.
                  <br />
                  <br />
                  • Evaluate key operational practices of the company and its associates to determine
                  that they align with contract terms and reduce financial risk of non-compliance.
                  <br />
                  <br />
                  • Analyze the practices of suppliers to evaluate whether they comply with contract
                  terms.
                  <br />
                  <br />
                  • Develop and maintain spreadsheets of key contracts, expiry and renewal dates,
                  options and option deadlines or expiry dates, and key contract terms.
                  <br />
                  <br />
                  • Maintain organized written and electronic files of company standard term contracts.
                  <br />
                  <br />
                  • Co-ordinate the work of outside legal counsel in the U.S. and Mexico to provide
                  evaluation of legal questions to the company or to affiliated companies in Mexico.
                  <br />
                  <br />
                  • Provide analysis in writing or verbally to the Company or to affiliated companies
                  in Mexico.
                  <br />
                  <br />
                </div>
                <b>Required:</b>
                <br />
                <div style={{ marginLeft: '40px' }}>
                  • Bachelor’s Degree in Law, Management, Economics, Account or related field.
                  <br />
                  <br />
                  • Min 2 years experience as Contract Analyst review contracts including financial
                  agreements, loan finance contracts, purchase sale contracts collateralization
                  agreements movable property liens under Mexican law.
                  <br />
                  <br />
                  • Knowledge of English and Spanish.
                  <br />
                </div>
                <br />
                Please send resumes <a href="mailto:jabreu@multikrd.com?subject=Senior Contract Analyst">jabreu@multikrd.com</a>
                &nbsp;reference “Senior Contract Analyst".
              </motion.div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

const roles = [
  'Operations',
  'Marketing',
  'Engineering & Technology',
  'Sales & partnerships',
  'Finance & Accounting',
  'Research & Development',
  'Customer Service',
  'Legal and Compliance'
]

